import { useMutation } from "@tanstack/react-query";
import { resendVerifyUserEmail } from "../../apis/user";

type ResendVerifyEmailParams = {
  email: string;
};

export function useResendVerifyEmail() {
  const { mutate, data, error, status, reset } = useMutation({
    mutationFn: ({ email }: ResendVerifyEmailParams) => {
      return resendVerifyUserEmail(email);
    },
  });

  return {
    resendVerifyUserEmail: mutate,
    result: data,
    error,
    status,
    reset,
    isLoading: status === "pending",
  };
}
